import React, { FC } from 'react';
import styles from './meta-box.module.sass';

export const MetaBoxHeader: FC<React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>> = ({
                                                                                                                     className,
                                                                                                                     ...props
                                                                                                                   }) => {
  return <span {...props} className={`${styles.header} ${className ?? ''}`}>{props.children}</span>;
};
export default MetaBoxHeader;
